/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppService } from '../api.service';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { ProjectsService } from './project.service';
import { LocalStorageService } from './localstorage.service';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BuyAtStoreService {
  temp_last_date!: Date;
  open_hours_list: { name: string; value: string; time: string }[]=[
    { name: '10AM - 12PM', value: '10:00:00', time: '10AM' },
    { name: '12PM - 2PM', value: '12:00:00', time: '12PM' },
    { name: '2PM - 4PM', value: '14:00:00', time: '2PM' },
    { name: '4PM - 6PM', value: '16:00:00', time: '4PM' },
    { name: '6PM - 8PM', value: '18:00:00', time: '6PM' },
    { name: '8PM - 10PM', value: '20:00:00', time: '8PM' }
  ];
  displayAppointmentDialog!: boolean;
  selectedDate!: Date;// = new Date();
  selectedTime: any;
  storevisitsId: any;
  customer_name: any;
  customer_type: any;
  name_field!: boolean;
  part_number!: string;
  afterRunMethod!: string;
  display_basic_info!: boolean;
  appointmentForm!: FormGroup;
  isNameError!: boolean;
  inline_loader!: boolean;
  dealer: any;
  project_id: any;
  appointment_book_succuess_popup!: boolean;

  is_chacekout_loader!: boolean;
  selectedTimeIndex!: any;
  constructor(private _fb: FormBuilder,public _as:AppService,private datePipe: DatePipe, private _router: Router,private _project:ProjectsService,private localStorageService: LocalStorageService) { }
  checkBasicInfor() {
    const user_info = JSON.parse(this.localStorageService.getItem('user_info') || "");
    this.customer_name = user_info.userProfile.username;
    this.customer_type = user_info.userProfile.customer_type;
    if (!this.customer_name) {
      this.name_field = true
    }
    if (!user_info.userProfile.is_mobile_verify || !user_info.userProfile.username || !user_info.userProfile.customer_type || user_info.userProfile.customer_type == 'none') {
      return false
    }
    return true
  }
  closedisplayAppointment() {
    this.displayAppointmentDialog = false;
  }
  getAppointmentForm() {
    this.appointmentForm = this._fb.group({
      'name': ['', []],
      'lastname': ['', []],
      'date': ['', [Validators.required]],
      'time': ['', [Validators.required]],
      'message': ['', [Validators.required]],
    });
  }
  onTime(time: any, ti: number) {
    this.selectedTime = time;
    this.selectedTimeIndex = ti;
    this.appointmentForm.controls['time'].setValue(time.value);
    // this.onAppointmentdata(this.appointmentForm.value);
  }
  getData() {
    return of('Hello World');
  }
  onAppointmentdata(data: any,) {
    if (!this._as.user_info.userProfile.username) {
      this.isNameError = true;
      return
    }
    const inputDate = new Date(this.selectedDate);
    const formattedDate = this.datePipe.transform(inputDate, 'yyyy-MM-ddTHH:mm:ssZ');
    this.inline_loader = true;
    const fdata = {
      dealer: this.dealer.id,
      project: this._project.selectedProject.id,
      date: formattedDate,
      time: this.selectedTime.value,
      name: data.name?data.name:this._as.user_info.userProfile.username,
      lastname: data.lastname?data.lastname:this._as.user_info.userProfile.last_name,
      location: this._as.user_location.locality,
      city: this._as.user_location.city,
    }
    
    const url = this._as.api_base_url + 'user/appointment/';
    this._as.postRequest(url, fdata, true)
      .subscribe((res: any) => {
        this.storevisitsId = res.appo_id;
        this.displayAppointmentDialog = false;
        this.appointment_book_succuess_popup = true;
        // this.selectedDate = null;
        this.is_chacekout_loader = false
        setTimeout(() => {
          this.checkAppointment()
        }, 500);
        if (!this._as.user_info.userProfile.username) {
          const user_info = JSON.parse(this.localStorageService.getItem('user_info') || "");
          this._as.user_info.userProfile.username = data.name
          user_info.userProfile.username = data.name;
          this.localStorageService.setItem('user_info', JSON.stringify(user_info));
         
        }
        this.dealer = null;
        this.selectedTime = null;
        this.selectedTimeIndex = null;
        this.inline_loader = false;
      },
        (err: any) => {
          if(err){
          this.inline_loader = false;
          }
        });
  }
  checkAppointment() {
    this.appointment_book_succuess_popup = false;
    this._router.navigate(['store-visits/detail/' + this.storevisitsId])
  }
  displayAppointment(dealer:any) {
    this.dealer = dealer;
    if (!this.checkBasicInfor()) {
      if (!this.customer_name || !this.customer_type || this.customer_name == 'none' || this.customer_type == 'none') {
        this.part_number = 'one';
      } else {
        this.part_number = 'two';
      }
      this.afterRunMethod = 'appontment';
      this.display_basic_info = true;
      return
    }
    this.open_hours_list = [
      { name: '10AM - 12PM', value: '10:00:00', time: '10AM' },
      { name: '12PM - 2PM', value: '12:00:00', time: '12PM' },
      { name: '2PM - 4PM', value: '14:00:00', time: '2PM' },
      { name: '4PM - 6PM', value: '16:00:00', time: '4PM' },
      { name: '6PM - 8PM', value: '18:00:00', time: '6PM' },
      { name: '8PM - 10PM', value: '20:00:00', time: '8PM' }]
    this.temp_last_date = new Date();
    this.updateTimeSlots();
    // this.temp_last_date.setDate(this.temp_last_date.getDate() + 1);
    this.displayAppointmentDialog = true;
  }
  onDateSelect() {
    if (this.temp_last_date < this.selectedDate) {
      this.open_hours_list = [
        { name: '10AM - 12PM', value: '10:00:00', time: '10AM' },
        { name: '12PM - 2PM', value: '12:00:00', time: '12PM' },
        { name: '2PM - 4PM', value: '14:00:00', time: '2PM' },
        { name: '4PM - 6PM', value: '16:00:00', time: '4PM' },
        { name: '6PM - 8PM', value: '18:00:00', time: '6PM' },
        { name: '8PM - 10PM', value: '20:00:00', time: '8PM' }]
    }
    else {
      this.updateTimeSlots();
    }
  }

  updateTimeSlots() {
    const currentTime = new Date().getTime();
    this.open_hours_list = this.open_hours_list.filter(slot => {
      const slotTime = new Date().setHours(
        parseInt(slot.value.split(':')[0]),
        parseInt(slot.value.split(':')[1]),
        parseInt(slot.value.split(':')[2])
      );
      return slotTime > currentTime;
    });
  }
}
